// ---------------------------------------------------------------------------
// NRAD Almanac 2026, content + real brand assets
// ---------------------------------------------------------------------------
const A = "https://customer-assets.emergentagent.com/job_nrad/artifacts";

export const ASSETS = {
 // Logos
 nradLogo: `${A}/k84v4sq7_nradlogo1.png`,
 vrgBadge: `${A}/dufxssm4_roundlogogreen.webp`,
 carbon8Round: `/carbon8_clean.png`,
 carbon8Mark: `${A}/0frvsqv7_Carbon8_Logomark%20copy.png`,

 // Watercolour community portraits (transparent PNG, primary visual language)
 wcRedCap: `${A}/db1kd69x_Untitled-1.png`, // man, red cap, arms crossed
 wcWalking: `${A}/bm5j894c_lady.png`, // corrected watercolour (woman with grass)
 wcAkubra: `${A}/bzujjyu1_cowboy.png`, // man in akubra, thoughtful
 wcGrass: `${A}/mogsugod_4.png`, // woman, hat + sunglasses, grass
 wcSmile: `${A}/mqc3t7p7_3.png`, // smiling woman, red cap
 wcWatch: `${A}/1udizzqq_Untitled-2.png`, // older man, yellow shirt, watch

 // Real contributor photography
 joshuaGilbert: `${A}/fdy66qz9_52d4e91772c641769960da086cc6e83c.webp`,
 nicoleMasters: `${A}/wy9ojh8s_Cattle_Drive-69-nicole-bio-768x778.jpg`,
 rachaelTreasure: `${A}/c9l902pt_Treasure-Rachael-2014-credit-Alastair-Bett.webp`,
 rebeccaGorman: `${A}/dxzyw4zy_yabtree-west-rebecca-and-son-with-plants.webp`,
 contributorMan: `${A}/0vf4wju8_94fc4fe0306ae775c71d81810d03705e.webp`, // grey hair, wheat bg
 contributorWoman: `${A}/m7738p7s_142470au.webp`, // grey hair, shell necklace

 // Real community & landscape photography (supporting layer)
 workshopFront: `${A}/x1xr0rfq_DSC05286.webp`, // farmers seated, listening
 workshopSide: `${A}/f7fbvr26_DSC05546.webp`, // workshop, side view
 speaker: `${A}/f33iax7w_DSC05688.webp`, // Carbon8 shirt, speaking
 gathering: `${A}/xgv0l7y3_DSC05747.webp`, // community outside country hall
 windmill: `${A}/bdr421k7_DSC05452.webp`, // windmill + tank, big sky
 windmillWide: `${A}/mncsa86j_DSC05752.webp`,
 gumtree: `${A}/65fmos2o_DSC06207.webp`,
 convoIndoor: `${A}/3zw71zq6_DSC06276.webp`,
 convoOutdoor: `${A}/782b7p7s_DSC05817.webp`,
 elderCoffee: `${A}/mmq8hqaa_DSC06229.webp`,
 soilPit: `${A}/y7um3luy_DSC06525.webp`,
 mikeTeach: `${A}/rcnnlom8_DSC06420.webp`,
 fieldWalk: `${A}/oa54t12h_DSC06674.webp`,
 regenTee: `${A}/gnc6pzul_DSC06672.webp`,
 crowd: `${A}/20bapd7t_DSC06635-2.webp`,

 // Landscape photography (immersive, full-bleed)
 billabong: `${A}/w00vcnh1_10.png`,
 fenceline: `${A}/m4nvdv3d_11.png`,
 cattleGum: `${A}/gdbsjn2x_12.png`,
 barnCattle: `${A}/ys33p830_13.png`,
 stockman: `${A}/ik07rqgo_14.png`,
 jacaranda: `${A}/f16ha8yy_15.png`,
 chickens: `${A}/3ns5tyop_16.png`,
 piglets: `${A}/w51hbgvr_17.png`,
 wheat: `${A}/l050c1wg_18.png`,
 valley: `${A}/tj5ncro1_20.png`,

 // Named watercolour contributor portraits
 wcMattEvans: `${A}/6nzoi9aa_matt%20evans.png`,
 wcJoshua: `${A}/vqmgk6te_joshua%20gilbert.png`,
 wcJade: `${A}/xrvw53b5_jademiles.png`,
 wcEli: `${A}/f7t8vbim_elicourt.png`,
 wcChris: `${A}/897pvv7u_chris%20hall.png`,
 wcRachelWard: `${A}/8hurm86i_rachelward.png`,
 wcNicole: `${A}/ejkoikew_nicole%20masters.png`,
 wcRachaelT: `${A}/xlvoqgcz_racheltreasure.png`,
 wcRebecca: `${A}/sbzjkd0v_rebecca%20gorman.png`,
 wcHelenLewis: `${A}/rbcip5r6_HELEN%20LEWIS.png`,
 wcAnthonyJames: `${A}/6yjoglfc_ANTHONY%20JAMES%20Host%2C%20The%20RegenNarration%20podcast.png`,
 wcMurrayGray: `${A}/50q5gr8t_MURRAY%20GRAY%20CEO%2C%20Sustainable%20Table.png`,
 wcMattHaggerty: `${A}/zxv57y3s_MATT%20HAGGATEY.png`,
 wcRachelleArmstrong: `${A}/q63ftnh8_RACHEL%20ARMSTRONG.png`,
 wcUncleLewis: `${A}/9kiun3or_UNCLE%20LEWIS%20WALKER.png`,
};

// Contributor quotes woven across the site as immersive moments 
// watercolour + quote are the feature; landscape sits faint in the background only.
export const BANDS = {
 country: { bg: "jacaranda", wc: "wcJoshua", variant: "dark", kicker: "Joshua Gilbert", quote: "The truth is hidden in Country. Country always tells us the truth back as to how we're going.", author: "First Nations farmer & author" },
 soil: { bg: "wheat", wc: "wcRachaelT", variant: "light", kicker: "Rachael Treasure", quote: "That little micro-universe between the plant and the soil, it's just mind-blowing.", author: "Author & regenerative farmer, Tasmania" },
 culture: { bg: "valley", wc: "wcMattEvans", variant: "dark", kicker: "Matthew Evans", quote: "Farming is a culture. Ask someone to change their farming system, and you're asking them to change their identity.", author: "Chef & co-founder, Grounded Festival" },
};

export const PHOTOS = [
 { src: "soilPit", cap: "The soil pit, in session" },
 { src: "mikeTeach", cap: "Reading the ground together" },
 { src: "gathering", cap: "Lunch outside the country hall" },
 { src: "workshopFront", cap: "Soil school, Upper Hunter" },
 { src: "fieldWalk", cap: "Walking the paddock" },
 { src: "crowd", cap: "The Carbon8 community" },
 { src: "elderCoffee", cap: "A quiet cuppa" },
 { src: "convoOutdoor", cap: "Yarns after the session" },
];

export const HERO = {
 eyebrow: "Carbon8 presents · 2026–2027",
 title: [
 "A National Record",
 "& People's Almanac",
 "of Regenerative",
 "Agriculture",
 ],
 titleTail: "in Australia",
 sub: "The shared story of Australia's regenerative agriculture movement, 2026–2027.",
 ctaPrimary: "Reserve Your Page",
 ctaSecondary: "Get Notified",
};

// Vision / manifesto (verbatim from Carbon8 issue plan)
export const VISION = {
 kicker: "The Vision",
 pull: "Regeneration requires not only action on land, but coherence in narrative.",
 chapters: [
 {
 n: "01",
 title: "A gathering of voices",
 body: "The Almanac gathers the voices, profiles, experience and knowledge of farmers, scientists, First Nations land custodians, organisations and community organisers who are rebuilding how the country produces food and fibre and restores our soil.",
 },
 {
 n: "02",
 title: "The isolation of the work",
 body: "This work is often carried out in isolation, without much sense of who else is doing it or how far it reaches. Farming is already one of the more mentally taxing professions, and the sense of doing hard, uncertain work alone can compound it.",
 },
 {
 n: "03",
 title: "Closing the gap",
 body: "The Almanac exists to close that gap, to give farmers a shared record of the movement they're part of, and to give communities a way into a conversation usually confined to paddocks and field days.",
 },
 ],
};

export const PILLARS = [
 {
 key: "ledger",
 title: "A Ledger",
 line: "This is what was true in 2026.",
 body: "A record put down in ink, the policy negotiations, the verification programs, the family farm that grew from 1,600 to 60,000 acres farming regeneratively.",
 icon: "BookOpen",
 },
 {
 key: "mirror",
 title: "A Mirror",
 line: "The movement, reflected back.",
 body: "For farmers doing hard, uncertain work alone: proof of how far the movement reaches, and who else is out there in it with you.",
 icon: "Sparkles",
 },
 {
 key: "forum",
 title: "A Forum",
 line: "A way into the conversation.",
 body: "A doorway for communities into a conversation usually confined to paddocks and field days, original interviews and commissioned pieces from the people doing the work.",
 icon: "Users",
 },
 {
 key: "celebration",
 title: "A Celebration",
 line: "Hope, in print.",
 body: "Positivity and hope, gathered and celebrated, the culture, the craft and the character of regeneration across the country.",
 icon: "PartyPopper",
 },
];

export const EDITION = {
 kicker: "Inside the 2026 Edition",
 intro: "A full-colour, perfect-bound volume built from original interviews and commissioned pieces, and, like the movement it records, entirely compostable.",
 groups: [
 {
 name: "Foundations",
 items: [
 { title: "Editor's Letter", by: "Kylie Woodham", pages: "1", desc: "Why voices from the land, now, framing the Almanac and its themes of hope." },
 { title: "Founders' Letter", by: "Mike, Helen & Kelly", pages: "1", desc: "The evolution and history of Carbon8 over the past twelve months." },
 { title: "Regen, Decoded", by: "Glossary", pages: "1", desc: "Plain-language definitions: set stocking, EOV, natural capital, biological brews, ground cover." },
 ],
 },
 {
 name: "Features",
 items: [
 { title: "Festival of Grounded", by: "Matthew Evans", pages: "6", desc: "Creating spaces for farmers and educators to gather and learn." },
 { title: "Farming Country", by: "Joshua Gilbert", pages: "6", desc: "Indigenous knowledge, connection to Country and the future of regen ag." },
 { title: "Proof in the Paddock", by: "Mike McCosker", pages: "8", desc: "What 'regenerative' on a label means, soil carbon, biodiversity, water." },
 { title: "Knowing Your Farmer", by: "Rachel Ward", pages: "6", desc: "Land, food and FarmThru, the journey through the 'missing middle'." },
 { title: "Bringing Through the Next Generation", by: "Nicole Masters", pages: "6", desc: "Inspiring the next generation, and the importance of mindset." },
 { title: "The Big Picture", by: "Helen Lewis", pages: "6", desc: "Why measuring regen impact is hard, and why verification matters." },
 { title: "Our Connection to Water & Land", by: "Anthony James", pages: "6", desc: "Reading and listening to the landscape." },
 { title: "Regen in the Bedroom", by: "Rachael Treasure", pages: "6", desc: "Delivering regen to new audiences; stockmanship and instinct." },
 ],
 },
 {
 name: "The Data",
 items: [
 { title: "The Economic Case", by: "ABARES · Clean Energy Regulator", pages: "3", desc: "Year-1 vs year-5 transition costs, input cost reductions and price premiums for verified regenerative produce." },
 { title: "Farmer Mental Health & Isolation", by: "NFF · National Rural Health Alliance", pages: "3", desc: "The scale of isolation in agriculture, and how co-ops, coaching and gatherings counter it." },
 { title: "Policy & Program Alignment Map", by: "Carbon8 & partners", pages: "2", desc: "How regen ag already maps to the ERF, National Soil Strategy, Landcare and the Future Drought Fund." },
 { title: "Policy Recommendations", by: "The sector, synthesised", pages: "4", desc: "Specific, ownable asks: named funding streams, extension-service changes and regulatory adjustments." },
 ],
 },
 {
 name: "Extras",
 items: [
 { title: "Chris Hall's Story", by: "Carbon8-verified grower", pages: "6", desc: "A personal account of an interview and its impact on family." },
 { title: "Photography", by: "Across the country", pages: "16", desc: "Scone, Tamworth, Hawkesbury, MacIntyre, Belltrees Public School and beyond." },
 { title: "The Reading Stack", by: "The C8 Library", pages: "2", desc: "Short descriptions of books shaping the movement." },
 { title: "Festivals", by: "National listing", pages: "2", desc: "Australian events, festivals and regen places worth the drive." },
 ],
 },
 ],
};

// 14 attributed quotes (verbatim from Carbon8 Promo Quotes doc).
// portrait = asset key (watercolour or photo) or null; kind = 'wc' | 'photo' | null.
export const VOICES = [
 { quote: "It's very easy to claim to be an environmentalist and to care about the land, but what are you actually doing about that?", name: "Rachel Ward", role: "Actor-turned-regenerative farmer, co-founder FarmThru, Nambucca Valley, NSW", portrait: "wcRachelWard", kind: "wc" },
 { quote: "You can turn desert into soil.", name: "Helen Lewis", role: "CEO, Australian Holistic Management Co-operative", portrait: "wcHelenLewis", kind: "wc" },
 { quote: "It is a way of management that enables you to think in wholes.", name: "Rebecca Gorman", role: "Founder, Regenerative Food and Farming Alliance (RFFA)", portrait: "wcRebecca", kind: "wc" },
 { quote: "Regeneration isn't just what happens on your land. If your neighbour isn't in it too, then we're failing.", name: "Anthony James", role: "Host, The RegenNarration podcast", portrait: "wcAnthonyJames", kind: "wc" },
 { quote: "It teaches us to slow down. It teaches us to sit on the earth. It teaches us to listen, not just with our ears, but with all of our skin.", name: "Jade Miles", role: "Author & outgoing CEO, Sustainable Table, Black Barn Farm, VIC", portrait: "wcJade", kind: "wc" },
 { quote: "Leaving the land in a better way than you found it.", name: "Rachelle Armstrong", role: "Carbon8 farm business coach, Soil Restoration Farming", portrait: "wcRachelleArmstrong", kind: "wc" },
 { quote: "We're social creatures. That's the way we learn, that's the way we've always learned.", name: "Eli Court", role: "CEO, Soils for Life", portrait: "wcEli", kind: "wc" },
 { quote: "It's farming in harmony with nature and community.", name: "Murray Gray", role: "CEO, Sustainable Table", portrait: "wcMurrayGray", kind: "wc" },
 { quote: "I feel that the food that we can grow using regen practices is superior to anything else.", name: "Chris Hall", role: "Hall Family Orchards, Carbon8-verified grower", portrait: "wcChris", kind: "wc" },
 { quote: "Mum and Dad have grown the farm since they started these practices, from 1,600 acres to 60,000 acres.", name: "Matt Haggerty", role: "Next-generation grazier, Natural Intelligence Farming", portrait: "wcMattHaggerty", kind: "wc" },
 { quote: "You can't decouple land health from human health.", name: "Nicole Masters", role: "Agroecologist & soil health educator, Integrity Soils", portrait: "wcNicole", kind: "wc" },
];

export const NUMBERS = [
 { value: "3,000+", label: "farmers & policy makers reached" },
 { value: "~200", label: "pages of original interviews & commissioned work" },
 { value: "20", label: "advertising & sponsor pages available" },
 { value: "$1,000", label: "per full page, a stake in the movement" },
 { value: "$20k", label: "goal to bring the first edition to print" },
 { value: "100%", label: "compostable, the book returns to the soil" },
];

export const PAGE_SIZES = [
 "Full Page, $1,000",
 "Half Page",
 "Quarter Page",
 "Business Card",
 "Not sure yet, advise me",
];

export const RESERVE = {
 kicker: "Reserve Your Page",
 heading: "Put your name in the ledger.",
 body: "The Almanac reaches the audience advertisers and investors want most and struggle hardest to find directly: working farmers already committed to transition, and a wider public asking where its food comes from. Twenty pages. One edition. This is what will be true in 2026.",
 email: "gday@carbon8.org.au",
};

export const ALMANAC = {
 kicker: "The People's Almanac",
 heading: "A living record of the movement.",
 body: "Real farmers, real challenges, real solutions - the problems they've faced, how they turned to regen ag, and the policy change they want to see. Field photography from the paddocks, the coffee mornings, the workshops. A scrapbook of a movement that's actually happening, not a stock-image version of it. Every edition adds to the record - it doesn't reset each year, it grows.",
 gallery: [
 { src: "wcRedCap", cap: "The grower", tag: "Watercolour" },
 { src: "wcGrass", cap: "Reading the pasture", tag: "Watercolour" },
 { src: "wcAkubra", cap: "A quiet moment", tag: "Watercolour" },
 { src: "wcSmile", cap: "Verified RegenGrown", tag: "Watercolour" },
 { src: "wcWatch", cap: "Time on the land", tag: "Watercolour" },
 { src: "wcWalking", cap: "Walking the fenceline", tag: "Watercolour" },
 ],
};

// The Australia Regenerative Agricultural Report 2026-27, the hard-data spine
// bundled inside the Almanac and released as a free, citable standalone document.
export const REPORT = {
 kicker: "The Report",
 eyebrow: "Bundled inside the Almanac",
 heading: "The Australia Regenerative Agricultural Report",
 headingTail: "2026–2027",
 lead: "For the first time, the hard data our community holds, soil health, economics, water, biodiversity and community impact, gathered into a single, coherent, properly sourced record.",
 body: "Printed inside the Almanac and released as a standalone document, freely available to farmers, policy makers, funders, researchers and the public. No paywall, no proprietary claim over the industry's own evidence. One credible, citable reference point instead of data scattered across dozens of separate organisations.",
 stats: [
   { value: "24", label: "pages of sourced, citable data" },
   { value: "Free", label: "no paywall, released to all" },
   { value: "12", label: "sections, from soil to policy" },
 ],
 contents: [
   { n: "01", title: "State of the Industry", pages: "2" },
   { n: "02", title: "The Economic Case", pages: "3" },
   { n: "03", title: "Environmental & Soil Data", pages: "3" },
   { n: "04", title: "Climate Resilience & Disaster Mitigation", pages: "2" },
   { n: "05", title: "Food & Water Security", pages: "2" },
   { n: "06", title: "Farmer Mental Health & Isolation", pages: "3" },
   { n: "07", title: "Regional Economic Impact", pages: "2" },
   { n: "08", title: "First Nations Land Management", pages: "2" },
   { n: "09", title: "Barriers to Adoption", pages: "2" },
   { n: "10", title: "Policy & Program Alignment Map", pages: "2" },
   { n: "11", title: "Policy Recommendations", pages: "4" },
   { n: "12", title: "Case Studies", pages: "3" },
 ],
 note: "Every data point traces back to a named organisation or dataset. Contributors are credited in full.",
};

export const MARQUEE = [
 "The soil remembers",
 "A record of what was true in 2026",
 "Farmers · Scientists · First Nations custodians",
 "100% compostable",
 "Coherence in narrative",
 "The shared story of a movement",
];

export const FOOTER = {
 acknowledgement: `Carbon8 acknowledges the Traditional Custodians of the lands on which we work, and Traditional Custodians of Country throughout Australia. We recognise that the practices this Almanac champions - reading the land, working with it rather than against it - are knowledge systems Aboriginal and Torres Strait Islander peoples have carried for over 60,000 years, long before "regenerative agriculture" had a name. We're grateful to the Elders and knowledge-holders, including those who have shared their stories in these pages, for the connection to Country they carry and continue to teach. We pay our respects to Elders past and present.`,
 email: "gday@carbon8.org.au",
 domain: "nradalmanac.com",
 address: "6335 Yetman Rd, Wallangra, NSW 2360",
 socials: ["Instagram", "Facebook", "LinkedIn"],
};
